import { createSlice } from '@reduxjs/toolkit';
import { paymentRequest } from './types';

export interface State {
  data?: any;
  error?: any;
  loading: boolean;
}

const initialState: State = {
  data: undefined,
  error: undefined,
  loading: false,
};

export const counterSlice = createSlice({
  name: paymentRequest,
  initialState,
  reducers: {
    getPaymentsData: () => {},
    paymentsApiCallLoadingRequest: (state) => {
      state.data = undefined;
      state.loading = true;
      state.error = undefined;
    },
    paymentsApiCallSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = undefined;
    },
    paymentsApiCallFailure: (state, action) => {
      if (state.data !== undefined) {
        state.data = undefined;
      }
      state.loading = false;
      state.error = action.payload;
    },
    resetPaymentsEncryptedData: (state) => {
      state.data = undefined;
      state.error = undefined;
      state.loading = false;
    },
  },
});

export const {
  getPaymentsData,
  paymentsApiCallLoadingRequest,
  paymentsApiCallSuccess,
  paymentsApiCallFailure,
  resetPaymentsEncryptedData,
} = counterSlice.actions;

export default counterSlice.reducer;
